import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium from 'radium';
import { connect } from 'react-redux';
import { Link as link, browserHistory} from 'react-router';
import { bindActionCreators } from 'redux';
import * as SelectionActions from '../../actions/Selection.js';
import Helpers from '../../helpers';

const Link = radium(link);

const styles = {
  contentWrap: {
    padding: '0 24px',
    '@media (max-width: 800px)': {
      marginBottom: 44,
    },
  },
  title: {
    color: '#a39671',
    padding: '24px 0 12px 0',
    fontSize: 18,
    fontWeight: 300,
    margin: 0,
    letterSpacing: 5,
  },
  list: {
    margin: '0 -12px',
    padding: 0,
    display: 'flex',
    width: 'calc(100% + 24px)',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
  },
  list_TV: {
    margin: '0 7%',
    padding: 0,
    display: 'flex',
    width: 'calc(100% + 24px)',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  item: {
    cursor: 'pointer',
    textDecoration: 'none',
    width: 347,
    height: 304,
    margin: 12,
    border: '1px solid #9b9b9b',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    padding: 14,
    fontSize: 18,
    color: '#4a4a4a',
    backgroundColor: '#fff',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center, center',
    ':hover': {
      border: '3px solid #fbbb0c',
      padding: 12,
    },
  },
  item_TV: {
    cursor: 'pointer',
    textDecoration: 'none',
    width: '40%',
    height: '450px',
    margin: 12,
    border: '1px solid #9b9b9b',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    padding: 14,
    fontSize: 18,
    color: '#4a4a4a',
    backgroundColor: '#fff',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center, center',
    ':hover': {
      border: '3px solid #fbbb0c',
      padding: 12,
    },
  },
  selected: {
    border: '3px solid #fbbb0c',
    padding: 12,
  },
  bottom: {
    position: 'fixed',
    bottom: 60,
    height: 44,
    color: '#fff',
    backgroundColor: '#9b9b9b',
    width: 'calc(100% - 250px)',
    padding: '0 24px',
    '@media (max-width: 800px)': {
      position: 'fixed',
      width: '100%',
    },
  },
  bottom_TV: {
    position: 'fixed',
    bottom: 60,
    height: 44,
    color: '#fff',
    backgroundColor: '#9b9b9b',
    width: '100%',
    padding: '0 24px',
    '@media (max-width: 800px)': {
      position: 'fixed',
      width: '100%',
    },
  },
  link: {
    float: 'right',
    fontSize: 18,
    fontWeight: 100,
    height: 18,
    lineHeight: '44px',
    padding: 0,
    color: '#fff',
    textDecoration: 'none',
  },
};

class SelectionTypeList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTypeId: null,
    };
  }

  componentWillMount() {
    return this.props.fetchSelections();
  }

  render() {
    const {
      list,
    } = this.props;

    const {
      selectedTypeId,
    } = this.state;

    var item = styles.item;
    var li = styles.list;
    var bottom = styles.bottom;

    if (Helpers.Session.isViaTV()) {
      item = styles.item_TV;
      li = styles.list_TV;
      bottom = styles.bottom_TV;
    }
    
    var next = <Link
                to={`/selections/characters?type=${selectedTypeId}`}
                onClick={(e) => {
                  if (!selectedTypeId) e.preventDefault();
                }}
                style={styles.link}>下一步</Link>
    
    if (Helpers.Session.isViaTV()) {
      next = null;              
    }       

    return (
      <div style={styles.wrap}>
        <div style={styles.contentWrap}>
          <h1 style={styles.title}>請選擇機型：</h1>
          <div style={li}>
            {list.map(type => (
              <div
                onClick={() => {
                  if (Helpers.Session.isViaTV()) {
                    browserHistory.push(`/selections/characters?type=${type.id}`);
                  }else {
                    this.setState({ selectedTypeId: type.id });
                  }
                }}
                style={[
                  item,
                  selectedTypeId === type.id && styles.selected,
                  {
                    backgroundImage: `url(${type.cover})`,
                  },
                ]}
                key={type.id}>{type.name}</div>
            ))}
          </div>
        </div>
        <div style={bottom}>{next}</div>
      </div>
    );
  }
}

SelectionTypeList.propTypes = {
  list: T.array,
  fetchSelections: T.func,
  backToHome: T.func,
  isLogined: T.bool,
};

export default connect(
  state => ({
    list: state.Selection.list,
    isLogined: state.Auth.isLogined,
  }),
  dispatch => bindActionCreators(SelectionActions, dispatch),
)(radium(SelectionTypeList));



// WEBPACK FOOTER //
// ./containers/Selections/SelectionTypeList.js